/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('RecipientNew', function($scope, recipientService, $rootScope, $q, _$editmode) {

    _$editmode.turnOn();

    $scope.printAfterSave = 0;

    $scope.tab = {
        title: "Nowy odbiorca",
        type: "add"
    };

    $scope.data = {
        "states": [],
        "filters": [],
        "activeNotifications": []
    };

    $scope.autocompletes = {
        "city": {
            "required": true,
            "name": null
        },
        "comunity": {
            "required": true,
            "name": null
        },
        "county": {
            "required": true,
            "name": null
        },
        "street": {},
        "loaded": true
    };

    $scope.row = {
        "info": {
            "active": false,
            "verified": false,
            "spamer": false
        },
        "data": {
            "name": "",
            "second_name": "",
            "surname": "",
            "birthdate": "",
            "nip": "",
            "pesel": "",
            "email": "",
            "epuap": "",
            //"sekap": "",
            "sex": null,
            "phone": ""
        },
        "address": {
            "comunity": "",
            "city": "",
            "postcode": "",
            "street": "",
            "home_nr": "",
            "local_nr": "",
            "county": "",
            "state": ""
        },
        "unit": [],
        "team": []
    };

    /*
     * save
     */

    $scope.checkRecipient = function(form) {
        if (form.$valid) {
            return true;
        } else {
            angular.forEach(form.$error, function(field) {
                angular.forEach(field, function(f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };

    $scope.saveRecipient = function(form) {
        var params = angular.copy($scope.row);

        params.data.birthdate = $rootScope.formatDate(params.data.birthdate);

        params.address.city = typeof $scope.autocompletes.city == "object" && $scope.autocompletes.city != null ? $scope.autocompletes.city.name : "";
        params.address.county = typeof $scope.autocompletes.county == "object" && $scope.autocompletes.county != null ? $scope.autocompletes.county.name : "";
        params.address.county_id = typeof $scope.autocompletes.county == "object" && $scope.autocompletes.county != null ? $scope.autocompletes.county.county_id : "";
        params.address.comunity = typeof $scope.autocompletes.comunity == "object" && $scope.autocompletes.comunity != null ? $scope.autocompletes.comunity.name : "";
        params.address.comunity_id = typeof $scope.autocompletes.comunity == "object" && $scope.autocompletes.comunity != null ? $scope.autocompletes.comunity.comunity_id : "";
        params.address.street = typeof $scope.autocompletes.street == "object" && $scope.autocompletes.street != null ? $scope.autocompletes.street.name : "";

        if(params.address.comunity.indexOf('(')!=-1){
          params.address.comunity = params.address.comunity.substring(0,params.address.comunity.indexOf('(')).trim();
        }

        var promise = recipientService.store(params);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    if ($scope.printAfterSave) {
                        setTimeout(function() {
                            $scope.printAfterSave = 0;
                            var promise = recipientService.printpdf(payload.data.id);
                            promise.then(function(payload) {
                                top.location.href = "/downloadpdf/" + payload.data;
                            });
                        }, 1000);
                    }

                    $rootScope.notification.showAfterRedirect('recipients', {}, 'success', payload.data.msg);
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Błąd dodawania odbiorcy');
            });
    };

    $scope.saveWithPrint = function(form) {
        $scope.printAfterSave = 1;
        $scope.saveRecipient(form);
    }

    $scope.init = function() {

        var promise = recipientService.create();
        promise.then(
            function(payload) {
                $rootScope.filters = payload.data.filters;


                $scope.autocompletes.county = {
                    "county_id": payload.data.county_id,
                    "name": payload.data.county,
                    "required": true
                };

                $scope.row.address.county = payload.data.county;
                $scope.row.address.state = payload.data.state;
                $scope.subunitSupported = payload.data.subunitSupported;
                $scope.teamSupported = payload.data.teamSupported;
                $scope.data.activeNotifications = ['email','epuap','sms','mobile'];//payload.data.activeNotifications;
            },
            function(errorPayload) {
                $rootScope.notification.showAfterRedirect('recipients', {}, 'error', 'Błąd wyświetlania listy odbiorców');
            });
    };

    $scope.init();

});
